/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React, { useState } from 'react';
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from 'react-helmet'

import SkipToMainContent from './jsx-components/SkipToMainContent';
import Header from "./jsx-components/header"
import Footer from "./jsx-components/footer"

import "./styles.scss"
import GlobalISI from "./jsx-components/global-isi"

import HcpModal from './jsx-components/hcp-modal';
const Layout = ({ site="gateway", children }) => {

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)


  const [modalIsOpen, setModalIsOpen] = useState(true);
  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <Helmet>
        <link rel="robots" type="text/plain" href="/robots.txt" /> 
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes" />
      </Helmet>
      <Helmet>
        <link rel="robots" type="text/plain" href={`/robots.txt`} /> 
      </Helmet>
      <HcpModal isOpen={modalIsOpen} closeModal={closeModal} site={site} />
      <SkipToMainContent />
      <div className={'shell '+ site}>
        <Header siteTitle={data.site.siteMetadata?.title || `Title`} site={site} />
        <div id="main-content" className="main-container" role="main">
          <main>{children}</main>
        </div>
        <div className='isi-intersection' id="isi">
          <GlobalISI site={site} />
        </div>
        
        <Footer siteTitle={data.site.siteMetadata?.title || `Title`} site={site} />
        <script type="text/javascript" defer="defer" src="https://extend.vimeocdn.com/ga4/12083149.js"></script>
      </div>
    </>
  )
}

export default Layout
